import { Injectable } from '@angular/core';
// import { UserTokenModel } from '../models/app-storage-service/user-token.model';
// import { UserDataResponse } from '../models/user-service/user-data-model';

const enum StorageKeys {
  AppToken = 'app:base:api:token',
  UserToken = 'app:user:api:token',
  UserData = 'app:user:api:data',
}

@Injectable({
  providedIn: 'root',
})
export class AppStorageService {
  constructor() {}

  get appToken(): string {
    return localStorage.getItem(StorageKeys.AppToken) ?? '';
  }

  set appToken(token: string) {
    localStorage.setItem(StorageKeys.AppToken, token);
  }

  deleteAppToken() {
    localStorage.removeItem(StorageKeys.AppToken);
  }

  get userToken(): string | null {
    return localStorage.getItem(StorageKeys.UserToken);
  }

  set userToken(token: string | null) {
    localStorage.setItem(StorageKeys.UserToken, token || '');
  }

  deleteUserToken() {
    localStorage.removeItem(StorageKeys.UserToken);
  }

  get userDataResponse(): any {
    let result = localStorage.getItem(StorageKeys.UserData) || '';
    return JSON.parse(result) 
  }

  set userDataResponse(data: any) {
    localStorage.setItem(StorageKeys.UserData, JSON.stringify(data));
  }

  deleteUserDataResponse() {
    localStorage.removeItem(StorageKeys.UserData);
  }
}
